import { ChevronRight, Loader2, RefreshCw, Send, Sparkles } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { ScrollArea } from "../ui/scroll-area";
import { useEffect, useRef, useState } from "react";
// import { useCreateRuleAI } from "@/hooks/useLocalStorage";
import { Rule } from "@/shared/schema";
import { useCreateFormAI } from "@/hooks/useLocalStorage";

interface GenerateRuleProps {
    onNext: () => void;
    generatedRule: string | null
    setGeneratedRule: (Rule: string | null) => void
    isGenerating: boolean
    setIsGenerating: (isGenerating: boolean) => void
}

interface ChatMessage {
    id: string;
    type: "user" | "ai";
    text: string;
    rule?: string | null;
    formId?: number
}

export const GenerateRuleStep = ({ onNext, setGeneratedRule, isGenerating, setIsGenerating }: GenerateRuleProps) => {
    const [prompt, setPrompt] = useState<string>('');
    const [preData, setPreData] = useState<Rule>();
    const [messages, setMessages] = useState<ChatMessage[]>([]);
    const [sessionId, setSessionId] = useState<string | null>(
        sessionStorage.getItem("rule_session_id")
    );

    const messagesEndRef = useRef<HTMLDivElement | null>(null);
    const prevPreDataRef = useRef<Rule | null>(null);

    const createFormPrompt = useCreateFormAI();

    useEffect(() => {
        const saved = sessionStorage.getItem("rule_chat_history");
        if (saved) setMessages(JSON.parse(saved));
        const editRuleData = localStorage.getItem("selectedRuleAI");
        if (editRuleData) {
            setMessages([])
            const ruleObj = JSON.parse(editRuleData ?? "")
            setPreData(ruleObj)
            setPrompt(`Edit rule with id ${ruleObj?.ID}`)
        }
    }, []);

    useEffect(() => {
        if (!preData) return;

        const prev = prevPreDataRef.current;

        if (JSON.stringify(prev) !== JSON.stringify(preData)) {
            prevPreDataRef.current = preData;

            setPrompt(`Edit rule with id ${preData.ID}`);
            onGenerate();
        }
    }, [preData]);

    useEffect(() => {
        sessionStorage.setItem("rule_chat_history", JSON.stringify(messages));
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const addMessage = (msg: ChatMessage) => {
        setMessages(prev => [...prev, msg]);
    };

    const cleanRule = (rule: string) => {
        return rule.replace(/[#\[\]@$]/g, "");
    };


    function toSoftWrapped(raw: string) {
        if (raw == null) return raw;
        let s = String(raw);

        for (let i = 0; i < 5 && s.includes("\\n"); i++) {
            s = s.replace(/\\n/g, "\n");
        }
        s = s.replace(/\n+/g, "\u200B");

        return s;
    }


    const onGenerate = async () => {
        if (!prompt.trim()) return;

        setIsGenerating(true);

        addMessage({
            id: crypto.randomUUID(),
            type: "user",
            text: `Max: ${prompt}`,
        });

        const Payload = {
            prompt: prompt,
            // session_id: sessionId || "",
        };


        try {
            const res: any = await createFormPrompt.mutateAsync(Payload);
            console.log("resq", res)
            const newRule = res?.Message || null;
            // const newSessionId = res?.session_id || null;
            const cleanedRule = newRule ? newRule : null;
            const formId = res?.workflow?.id || null;

            // if (newSessionId) {
            //     setSessionId(newSessionId);
            //     sessionStorage.setItem("rule_session_id", newSessionId);
            // }

            addMessage({
                id: crypto.randomUUID(),
                type: "ai",
                text: "Response from AI Assistant:",
                rule: cleanedRule,
                formId: formId,
            });

            setGeneratedRule(newRule);
            sessionStorage.setItem("generatedRule", newRule);
            setPrompt("");
        } catch (err) {
            addMessage({
                id: crypto.randomUUID(),
                type: "ai",
                text: "Please retry. Something went wrong.",
                rule: null,
            });

            setGeneratedRule(null);
        }

        setIsGenerating(false);
    };

    const handleClear = () => {
        setMessages([]);
        setGeneratedRule(null);
        sessionStorage.removeItem("rule_chat_history");
        sessionStorage.removeItem("rule_session_id");
        sessionStorage.removeItem("generatedRule");
        localStorage.removeItem("selectedRuleAI");
        localStorage.removeItem("selectedRule");
        localStorage.removeItem("selectedVersionRule");
        setPrompt("");
        setSessionId("")
    };
console.log("messages", messages)
    return (
        <div className="space-y-6">
            <Card>
                <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                        <Sparkles className="h-5 w-5 text-purple-500" />
                        Generate Your Workflow
                    </CardTitle>
                    <CardDescription>
                        Briefly Describe the AI Assistant the Workflow you want to create
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <div className="space-y-4">
                        <div className="space-y-2">
                            <ScrollArea className="h-[260px] w-full p-2 border rounded-md bg-muted/30">
                                <div className="flex flex-col gap-4 pr-2">

                                    {messages.map(msg => (
                                        <div
                                            key={msg.id}
                                            className={`max-w-[90%] p-3 rounded-xl text-sm shadow self-start
                                            ${msg.type === "user"
                                                    ? "bg-blue-100"
                                                    : "bg-green-100"}`}
                                        >
                                            <p className="font-medium">{msg.text}</p>

                                            {msg.rule && (
                                                <div
                                                    className="mt-2 p-2 bg-white border rounded text-sm font-mono overflow-auto"
                                                    style={{
                                                        whiteSpace: "normal",
                                                        wordBreak: "normal",
                                                        overflowWrap: "normal",
                                                        fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, 'Roboto Mono', monospace",
                                                    }}
                                                >
                                                    {toSoftWrapped(msg.rule)}
                                                </div>
                                            )}
                                            {msg.formId && (
                                                <Button
                                                    size="sm"
                                                    className="mt-2"
                                                    onClick={() => window.open(`https://workflow-designer.workfinity.com/workflow/${msg.formId}/preview`, '_blank')}
                                                >
                                                    Preview Workflow
                                                    <ChevronRight className="h-4 w-4" />
                                                </Button>
                                            )}
                                        </div>
                                    ))}
                                    <div ref={messagesEndRef} />
                                </div>
                            </ScrollArea>

                            <div className="space-y-2">
                                <Label htmlFor="prompt">Enter Prompt</Label>
                                <Textarea
                                    id="prompt"
                                    placeholder="Example: Create a workflow..."
                                    className="min-h-[120px]"
                                    value={prompt}
                                    onChange={(e) => setPrompt(e.target.value)}
                                    disabled={isGenerating}
                                />
                            </div>
                        </div>
                        <div className="flex justify-between items-center gap-2">
                            <div className="flex flex-row gap-2">
                                <Button
                                    type="submit"
                                    disabled={isGenerating}
                                    size="sm"
                                    onClick={onGenerate}
                                >
                                    {isGenerating ? 'creating Workflow...' : 'Create Workflow'}
                                    {isGenerating ? ( <Loader2 className="ml-2 h-4 w-4 animate-spin" /> ) : ( <Send className="ml-2 h-4 w-4" /> )}
                                </Button>

                                {messages.length > 0 &&
                                    <Button
                                        variant="outline"
                                        size="sm"
                                        onClick={handleClear}
                                    >
                                        <RefreshCw className="h-4 w-4" />
                                        Clear
                                    </Button>
                                }
                            </div>
                            {/* {isGenerating || messages.length > 0 && (
                                <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={onNext}
                                >
                                    Next
                                    <ChevronRight className="h-4 w-4" />
                                </Button>
                            )} */}
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};